import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const VisualizerBlurListItem = (props) => {
    const { glowSettingsBlur, updateVisualizerSettings, maxGlowBlur } = props;
    
    const onGlowBlurChange = (value) => {
        previewHistoryBatch.start();
        
        updateVisualizerSettings({ 
            glowSettings: { blur: value } 
        });
    };
    
    return (
        <SliderListItem
            title='Blur'
            value={glowSettingsBlur}
            displayMultiplier={100 / maxGlowBlur}
            min={0}
            max={100}
            step={1}
            onValueChange={onGlowBlurChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { blur: glowSettingsBlur } = state.createPreview.present.videoSettings.visualizer.glowSettings;
    const { maxGlowBlur } = state.create.maxValues;

    return { 
        glowSettingsBlur,
        maxGlowBlur
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerBlurListItem);